import { formatBytes, formatSpeed, formatTimeRemaining } from "@/lib/format";

const UploadProgress = ({ progress, uploadedBytes, totalBytes, speed }) => {
  return (
    <div className="w-full space-y-2">
      <div className="flex justify-between text-sm">
        <span className="font-medium">Uploading...</span>
        <span className="text-gray-600">{progress}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className="bg-gradient-to-r from-red-500 to-red-600 h-3 rounded-full transition-all duration-300 ease-out relative"
          style={{ width: `${progress}%` }}
        >
          <div className="absolute inset-0 bg-white opacity-30 animate-pulse"></div>
        </div>
      </div>
      <div className="flex justify-between text-xs text-gray-600">
        <span>{formatBytes(uploadedBytes)} / {formatBytes(totalBytes)}</span>
        <span>{formatSpeed(speed)}</span>
      </div>
      <div className="text-center text-xs text-gray-500">
        {formatTimeRemaining(totalBytes, uploadedBytes, speed)}
      </div>
    </div>
  );
};

export default UploadProgress;
